import { render, staticRenderFns } from "./ButtonsFloat.vue?vue&type=template&id=f0f8756e&scoped=true"
import script from "./ButtonsFloat.vue?vue&type=script&lang=ts"
export * from "./ButtonsFloat.vue?vue&type=script&lang=ts"
import style0 from "./ButtonsFloat.vue?vue&type=style&index=0&id=f0f8756e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f8756e",
  null
  
)

export default component.exports